import { render, staticRenderFns } from "./DonationChart.vue?vue&type=template&id=b5f380e2&scoped=true&lang=pug&"
import script from "./DonationChart.vue?vue&type=script&lang=js&"
export * from "./DonationChart.vue?vue&type=script&lang=js&"
import style0 from "./DonationChart.vue?vue&type=style&index=0&id=b5f380e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f380e2",
  null
  
)

/* custom blocks */
import block0 from "./DonationChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCol,VRow,VTab,VTabs})
